import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { isValidToken } from '../../utils/jwt';

const initialState = {
  isLoading: false,
  error: false,
  counter: []
};

const slice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getCounterSuccess(state, action) {
      state.isLoading = false;
      state.counter = action.payload;
    }
  }
});

export default slice.reducer;

export function getCounter(request) {
  const { mes } = request;
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      if (accessToken && isValidToken(accessToken)) {
        const response = await axios.get('/solicitud/contadores-home', {
          params: {
            mes
          }
        });

        // Enviar la data de las solicitudes que se encuentra en data
        dispatch(slice.actions.getCounterSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
